import type { Messages } from "@/i18n/messages/sq"

export const tr: Messages = {
    meta: {
        lang: "tr",
        dir: "ltr",
        siteTagline: "Yayınlar, çeviriler ve kurslar",
        siteDescription:
            "Germa Enstitüsü; yayıncılık, çeviri, Kur’an kursları ve yabancı dil eğitimi alanlarında çalışan bir kültür ve eğitim kurumudur."
    },

    languageNames: {
        sq: "Arnavutça",
        en: "İngilizce",
        de: "Almanca",
        es: "İspanyolca",
        tr: "Türkçe",
        bs: "Boşnakça",
        ar: "Arapça"
    },

    common: {
        home: "Ana sayfa",
        homeAria: "Germa Enstitüsü, ana sayfa",
        breadcrumb: "Sayfa yolu",
        mainNav: "Ana menü",
        menu: "Menü",
        openMenu: "Menüyü aç",
        closeMenu: "Menüyü kapat",
        contactUs: "Bize ulaşın",
        language: "Dil",
        chooseLanguage: "Site dilini seçin",
        instituteName: "Germa Enstitüsü"
    },

    nav: {
        libra: "Kitaplar",
        kurani: "Kur’an",
        videoleksione: "Video dersler",
        kurse: "Kurslar",
        audiolibra: "Sesli kitaplar",
        rrethNesh: "Hakkımızda",
        kontakt: "İletişim"
    },

    footer: {
        tagline:
            "İslami eserler yayımlıyor ve çeviriyoruz; Kur’an okuma ve yabancı dil kursları düzenliyoruz.",
        links: "Bağlantılar",
        books: "Kitaplar",
        allBooks: "Tüm kitaplar",
        contact: "İletişim",
        contactNote:
            "Kitap siparişi vermek, bir kursa kaydolmak ya da iş birliği önermek için bize yazın.",
        rights: "Tüm hakları saklıdır."
    },

    verse: {
        text: "De ki: “Rabbim! İlmimi artır.”",
        source: "Kur’an, 20:114"
    },

    home: {
        seoDescription:
            "Germa Enstitüsü’nden ücretsiz indirilebilir kitaplar, video dersler, sesli kitaplar ve Kur’an okuma ile yabancı dil kursları.",
        hero: {
            eyebrow: "Hoş geldiniz",
            intro:
                "Germa Enstitüsü bir kültür ve eğitim kurumudur. Dinî, dil ve eğitim alanlarında kitaplar yayımlıyor, video dersler hazırlıyor, Kur’an okuma ve yabancı dil kursları düzenliyoruz.",
            primaryCta: "Yayınlara göz atın",
            secondaryCta: "Kurslara kaydolun",
            pillars: ["Kitaplar", "Video dersler", "Kurslar", "Sesli kitaplar"],
            cue: "Daha fazlasını keşfedin",
            category: "Yayın",
            viewBook: "Kitabı görüntüle",
            previous: "Önceki kitap",
            next: "Sonraki kitap",
            goTo: "{number}. kitaba git"
        },
        marquee: {
            rowOne: ["Yayınlar", "Çeviriler", "Kur’an kursları", "Video dersler", "Sesli kitaplar", "Yabancı diller"],
            rowTwo: ["Kur’an Okuma Elifbası", "Tecvid", "İlim", "Eğitim", "Miras", "Çağdaş yöntem"]
        },
        about: {
            eyebrow: "Enstitü hakkında",
            title: "İlmin ve eğitimin hizmetinde",
            intro:
                "Çalışmalarımızın amacı, insanların öğrenmesine, dinlerini daha iyi tanımasına ve dil becerilerini geliştirmesine yardımcı olmaktır. Bu yüzden kitaplarımızın ve ders materyallerimizin doğru içerikli ve açık anlatımlı olmasına, kurslarımızın da öğrencilerin bilgi düzeyine ve ihtiyaçlarına uygun olmasına özen gösteriyoruz.",
            features: [
                "Dinî, dil ve eğitim alanlarında eserlerin yayımlanması ve çevirisi.",
                "Çevrimiçi ve yüz yüze Kur’an okuma ve yabancı dil kursları.",
                "İnternet üzerinden takip edebileceğiniz video dersler ve sesli kitaplar."
            ]
        },
        stats: {
            titles: "Yayımlanan eser",
            languages: "Yayın dili",
            fields: "Faaliyet alanı",
            online: "Çevrimiçi erişim"
        },
        services: {
            eyebrow: "Neler sunuyoruz",
            title: "Faaliyetlerimiz",
            more: "Daha fazla bilgi",
            items: {
                libra: {
                    title: "Kitaplar",
                    description:
                        "Germa Enstitüsü tarafından hazırlanan veya çevrilen dinî, dil ve eğitim kitapları.",
                    cta: "Kitapları inceleyin"
                },
                videoleksione: {
                    title: "Video dersler",
                    description: "Kur’an okuma ve diğer dinî ve eğitici konularda video dersler.",
                    cta: "Derslere göz atın"
                },
                kurse: {
                    title: "Kurslar",
                    description: "Yüz yüze ve çevrimiçi Kur’an okuma ve yabancı dil kursları.",
                    cta: "Kursları inceleyin"
                },
                audiolibra: {
                    title: "Sesli kitaplar",
                    description: "Dinlemeyi tercih edenler için seslendirilmiş yayınlarımız.",
                    cta: "Sesli kitapları dinleyin"
                }
            }
        },
        booksLocal: {
            title: "Türkçe kitaplar",
            description: "Türkçe yayınlarımız, hepsi ücretsiz olarak indirilebilir."
        },
        booksOther: {
            title: "Diğer dillerdeki kitaplar",
            description: "Arnavutça ve diğer dillerdeki yayınlarımız, bunlar da ücretsiz olarak indirilebilir."
        },
        booksCarouselTitle: "İz bırakan kitaplar",
        booksCarouselDescription:
            "Okur için özenle hazırlanmış dinî, eğitici ve kültürel eserler.",
        seeAllBooks: "Tüm kitapları gör",
        mostRead: {
            eyebrow: "Okurların tercihi",
            title: "En çok okunanlar",
            description: "Okurlarımızın en sık açtığı ve indirdiği kitaplar."
        },
        kurani: {
            badge: "Özel bir proje",
            title: "Kur’an-ı Kerim",
            subtitle: "Meâlinin Arnavutçaya çevirisi",
            text: "Kur’an-ı Kerim’i, Jusuf H. Kastrati’nin Arnavutça meâliyle birlikte okuyun. Meâl, Kurani.info’da ücretsiz olarak erişime açıktır.",
            cta: "Çeviri hakkında",
            readOn: "Kurani.info’da okuyun",
            logoAlt: "Kurani.info platformunun logosu",
            highlights: [
                {
                    title: "Doğruluk ve sadakat",
                    text: "Güvenilir tefsirlere dayanarak ayetlerin anlamlarının özenle aktarılması."
                },
                {
                    title: "Açık ve akıcı Arnavutça",
                    text: "Kur’an üslubunun özelliklerini, dilin imkânları ölçüsünde korumaya çalışan doğal bir Arnavutça."
                },
                {
                    title: "Açıklayıcı dipnotlar",
                    text: "Gerekli yerlerde ayetlerin anlaşılmasına yardımcı olan kısa açıklamalar."
                }
            ]
        }
    },

    cta: {
        eyebrow: "Bize katılın",
        title: "Kurslara kayıt, yayın siparişi veya iş birliği için bizimle iletişime geçin.",
        primary: "Kursları inceleyin",
        secondary: "Bize ulaşın"
    },

    books: {
        seoTitle: "İslami kitaplar",
        seoDescription:
            "Germa Enstitüsü kataloğu: Türkçe, Arnavutça ve diğer dillerde, profesyonelce çevrilmiş ve redakte edilmiş dinî, eğitici ve kültürel kitaplar.",
        listName: "Germa Enstitüsü yayınları",
        title: "Yayınlarımız",
        description:
            "Türkçe, Arnavutça ve diğer dillerdeki yayınlarımızı burada bulabilir, hepsini ücretsiz indirebilirsiniz.",
        crumb: "Kitaplar",
        searchLabel: "Kitap ara",
        searchPlaceholder: "Kitap adı veya yazara göre arayın",
        authorChip: "Yazar: {name}",
        clearAuthor: "Yazar filtresini kaldır",
        clearSearch: "Aramayı temizle",
        categoryLabel: "Kategori",
        allCategories: "Tüm kategoriler",
        languageLabel: "Dil",
        allLanguages: "Tüm diller",
        readingList: "Okuma listem",
        readingListHintBefore: "Bir kitabı buraya kaydetmek için",
        readingListHintAfter: "simgesine dokunun.",
        readingListEmpty:
            "Okuma listeniz henüz boş. Daha sonra okumak istediğiniz kitaplardaki kayıt simgesine dokunun.",
        foundOne: "1 kitap bulundu",
        foundMany: "{count} kitap bulundu",
        noResults: "Bu ölçütlere uygun kitap bulunamadı.",
        showAll: "Tüm kitapları göster",
        groupLocal: "Türkçe",
        groupOther: "Diğer dillerde",
        mostRead: "En çok okunan",
        publishedBy: "Germa Enstitüsü yayını",
        viewBook: "{title} kitabını görüntüle",
        coverAlt: "{title} kitabının kapağı",
        save: "Listeme ekle",
        saved: "Listemde",
        remove: "Listemden çıkar"
    },

    bookPage: {
        lang: "tr",
        dir: "ltr",
        about: "Kitap hakkında",
        highlights: "Öne çıkanlar",
        details: "Ayrıntılar",
        language: "Dil",
        languageName: "Türkçe",
        category: "Kategori",
        author: "Yazar",
        authorLine: "Yazar: {author}.",
        publishedBy: "Germa Enstitüsü yayını.",
        fallbackDescription: "{title}. {language} bir kitap.",
        publisher: "Yayınevi",
        cta: "Bu kitapla ilgileniyor musunuz? Sipariş veya daha fazla bilgi için bize yazın.",
        contact: "Bize ulaşın",
        home: "Ana sayfa",
        books: "Kitaplar",
        book: "Kitap",
        breadcrumb: "Sayfa yolu",
        coverAlt: "{title} kitabının kapağı",
        readOnline: "Çevrimiçi oku",
        orderOrAsk: "Sipariş ver veya sor",
        allBooks: "Tüm kitaplar",
        readerTitle: "Kitabı çevrimiçi okuyun",
        readerText: "Kitabın tamamına buradan ücretsiz göz atın.",
        openNewTab: "Yeni sekmede aç",
        relatedEyebrow: "Okumaya devam edin",
        moreByAuthor: "Yazarın diğer kitapları",
        allByAuthor: "Yazarın tüm kitapları",
        authorLinkTitle: "Bu yazarın kitaplarını gör",
        relatedTitle: "İlginizi çekebilir",
        seeAllBooks: "Tüm kitapları gör",
        otherEditions: "Bu kitap diğer dillerde",
        watchVideos: "Video dersleri izleyin",
        downloadPdf: "PDF indir",
        continueFrom: "{page}. sayfadan devam et",
        startOver: "Baştan başla",
        page: "Sayfa",
        pageOf: "/",
        prevPage: "Önceki sayfa",
        nextPage: "Sonraki sayfa",
        zoomIn: "Yakınlaştır",
        zoomOut: "Uzaklaştır",
        fullscreen: "Tam ekran",
        closeReader: "Okuyucuyu kapat",
        loadingBook: "Kitap açılıyor…",
        readerError: "Kitap burada açılamadı. Yeni sekmede açmayı deneyin.",
        saveBook: "Listeme ekle",
        savedBook: "Listemde",
        share: "Paylaş",
        copyLink: "Bağlantıyı kopyala",
        linkCopied: "Bağlantı kopyalandı",
        email: "E-posta",
        moreOptions: "Diğer seçenekler",
        displaySettings: "Okuma görünümü",
        themeLight: "Gündüz",
        themeSepia: "Sepya",
        themeNight: "Gece",
        pageSize: "Yazı boyutu",
        reviews: {
            title: "Okur değerlendirmeleri",
            intro: "Bu kitabı nasıl buldunuz? Yıldızla puan verin ve isterseniz diğer okurlar için birkaç söz yazın.",
            average: "5 üzerinden {average}",
            count: "{count} değerlendirme",
            countOne: "1 değerlendirme",
            empty: "Bu kitap için henüz değerlendirme yok. İlk değerlendiren siz olun.",
            formTitle: "Kitabı değerlendirin",
            ratingLabel: "Puanınız",
            star: "{count} yıldız",
            starOne: "1 yıldız",
            name: "Adınız",
            namePlaceholder: "örn. Elif",
            comment: "Yorum (isteğe bağlı)",
            commentPlaceholder: "Bu kitapta neyi beğendiniz?",
            submit: "Değerlendirmeyi gönder",
            sending: "Gönderiliyor…",
            success: "Teşekkürler! Değerlendirmeniz Enstitü tarafından incelendikten sonra yayımlanacak.",
            errorRating: "Lütfen kitaba kaç yıldız verdiğinizi seçin.",
            errorName: "Lütfen adınızı yazın (en az iki harf).",
            errorThrottled: "Bugün çok sayıda değerlendirme gönderdiniz. Lütfen yarın tekrar deneyin.",
            error: "Değerlendirme gönderilemedi. Lütfen biraz sonra tekrar deneyin.",
            moderated: "Değerlendirmeler Enstitü tarafından incelendikten sonra görünür."
        },
        quote: {
            button: "Alıntı paylaş",
            title: "Bir alıntı paylaşın",
            intro: "Kitap sayfasında fare ya da parmağınızla bir cümle seçin veya buraya yazın. Onu Instagram ya da WhatsApp için bir görsele dönüştürelim.",
            textLabel: "Alıntı",
            placeholder: "Sizi etkileyen cümleyi yazın veya yapıştırın…",
            formatLabel: "Görsel biçimi",
            square: "Kare (gönderi)",
            story: "Dikey (hikâye)",
            share: "Görseli paylaş",
            download: "Görseli indir",
            copyText: "Metni kopyala",
            copied: "Metin kopyalandı",
            close: "Kapat",
            tooLong: "Alıntı çok uzun. Lütfen biraz kısaltın (en fazla {max} karakter).",
            empty: "Görselde görünmesi için bir alıntı yazın.",
            fromSelection: "Alıntı olarak paylaş",
            preview: "Görselin önizlemesi",
            shareText: "“{title}” kitabından"
        }
    },

    share: {
        share: "Paylaş",
        copyLink: "Bağlantıyı kopyala",
        linkCopied: "Bağlantı kopyalandı",
        email: "E-posta",
        moreOptions: "Diğer seçenekler"
    },

    audiobooks: {
        seoTitle: "Arnavutça İslami sesli kitaplar",
        seoDescription:
            "Açık ve profesyonel biçimde seslendirilmiş Arnavutça dinî ve eğitici sesli kitaplar. İstediğiniz zaman, her cihazdan doğrudan sayfada dinleyin.",
        listName: "Germa Enstitüsü sesli kitapları",
        title: "Arnavutça sesli kitaplar",
        description:
            "Yayınlarımızın Arnavutça sesli hâlleri. Onları doğrudan bu sayfada dinleyebilir ya da üye olmadan ücretsiz indirebilirsiniz.",
        crumb: "Sesli kitaplar",
        comingSoon: "Çok yakında",
        comingSoonText: "Sesli kitaplarımız hazırlanıyor. İlk dinleyenlerden olmak için kanallarımızı takip edin.",
        badge: "Sesli kitap",
        author: "Yazar:",
        openBook: "Kitabı aç",
        resumeFrom: "{time} anından devam et",
        back15: "15 saniye geri",
        forward15: "15 saniye ileri",
        play: "Oynat",
        pause: "Duraklat",
        position: "Dinleme konumu",
        speedGroup: "Dinleme hızı",
        speed: "Hız",
        speedValue: "Hız {value}",
        download: "Sesli kitabı indir",
        youtube: "YouTube’da dinle",
        miniLabel: "Şu an dinleniyor",
        closePlayer: "Oynatıcıyı kapat",
        openAudiobook: "Sesli kitaba git",
        coverAlt: "{title} sesli kitabının kapağı",
        otherAudiobooks: "Diğer sesli kitaplar",
        allAudiobooks: "Tüm sesli kitaplar",
        openPage: "Sesli kitap sayfasını aç",
        pageSeoDescription: "“{title}” sesli kitabını Arnavutça olarak sayfada ücretsiz dinleyin veya kayıt olmadan indirin."
    },

    videos: {
        seoTitle: "Kur’an okumayı öğrenmek için video dersler",
        seoDescription:
            "Kur’an harflerini öğrenmek için Arnavutça, Almanca ve İngilizce {count} ücretsiz video ders: ilk harften akıcı okumaya kadar.",
        listName: "Germa Enstitüsü video dersleri",
        title: "Kur’an okumayı öğrenin",
        description:
            "Kur’an Okuma Elifbası video dersleri, Arap harflerini ve Kur’an okumayı adım adım öğrenmenize yardımcı olur. Dersler Arnavutça, Almanca ve İngilizce olup bu sayfada üye olmadan ücretsiz izlenebilir.",
        crumb: "Video dersler",
        chooseLanguage: "Dil seçin:",
        player: {
            videos: "video",
            youtube: "YouTube’da izleyin",
            list: "Ders listesi",
            promo: "Tanıtım videosu",
            promoShort: "Tanıtım",
            lesson: "Ders",
            of: "/",
            playing: "Oynatılıyor",
            shareLesson: "Dersi paylaş",
            openBook: "Kitabı görüntüle",
            markDone: "Öğrenildi olarak işaretle",
            done: "Öğrenildi",
            progress: "öğrenildi",
            resume: "Devam et:",
            lessonsDone: "{total} dersten {done} tanesi öğrenildi",
            progressLabel: "Bu serideki ilerleme",
            seriesDone: "Bu seriyi tamamladınız. Tebrikler!",
            progressHint: "Öğrendiğiniz dersleri işaretleyin ve ilerlemenizi takip edin.",
            prevLesson: "Önceki ders",
            nextLesson: "Sonraki ders",
            allLessons: "Serinin tüm dersleri",
            watchOnYoutube: "YouTube’da izle",
            aboutLesson: "Bu ders hakkında",
            backToSeries: "Seriye dön",
            openLessonPage: "Ders sayfasını aç",
            lessonIntro: "“{series}” serisinin {total} dersinden {number}. ders.",
            promoIntro: "“{series}” serisinin tanıtım videosu.",
            freeLesson: "Germa Enstitüsü’nden ücretsiz bir video ders, kayıt gerekmez."
        }
    },

    courses: {
        seoTitle: "Kur’an ve dil kursları",
        seoDescription:
            "İlk harflerden tecvidli okumaya kadar Kur’an kursları ve dil kursları. Çevrimiçi ve yüz yüze, kayıtlar açık.",
        listName: "Germa Enstitüsü kursları",
        title: "Kur’an okuma ve dil kursları",
        description:
            "Yeni başlayanlar ve bilgisini geliştirmek isteyenler için kurslar düzenliyoruz. Dersler, kursa ve gruba göre çevrimiçi ya da yüz yüze yapılır.",
        crumb: "Kurslar",
        posterAlt: "{title} kursunun afişi",
        teacher: "Öğretmen:",
        details: "Kurs ayrıntılarını inceleyin",
        listTitle: "Kurslarımız",
        listDescription:
            "Kur’an okuma ve tecvid kursları düzenliyoruz; Arapça kursumuzu da yeniden başlatmayı planlıyoruz. Her yeni grubun tarihleri, ders saatleri ve kayıt şekli ayrıca duyurulur.",
        registerTitle: "Bir kursa kaydolmak ister misiniz?",
        registerDescription:
            "İlginizi bildirmek için formu doldurun. Seçtiğiniz kurs için yeni bir grup açıldığında, başlangıç tarihi, ders saatleri ve derslerin işleyişi hakkında bilgi vermek üzere sizinle iletişime geçeceğiz.",
        plannedSuffix: "yeniden başlatılması planlanıyor",
        contactFallback: "Bize ulaşın",
        items: {
            "shkronjat-e-kuranit": {
                title: "Kur’an okumayı öğrenme",
                description:
                    "Kur’an Okuma Elifbası kitabına dayanan, yeni başlayan hanımlar için bir kurs. Arap harflerini tanıma ve doğru telaffuz etmeyle başlar, ardından harfleri kelimelerde birleştirmeye ve Kur’an okuma alıştırmalarına geçer.",
                level: "Yeni başlayan hanımlar için",
                format: "Çevrimiçi",
                badge: "Yeni başlayanlar için",
                summary:
                    "Kur’an Okuma Elifbası kitabına dayanan bu kurs, Arap harflerini tanıma ve telaffuzla başlar; harfleri kelimelerde birleştirme ve okuma alıştırmalarıyla devam eder.",
                cta: "Yeni gruplar için bize ulaşın"
            },
            "leximi-me-texhvid": {
                title: "Tecvid eğitimi",
                description:
                    "Tecvid kurallarının öğrenilmesi ve uygulanması; uygulamalı alıştırmalar ve okumanın düzeltilmesiyle.",
                level: "Kur’an okumayı bilenler için",
                format: "Çevrimiçi",
                badge: "",
                summary: "",
                cta: "Yeni gruplar için bize ulaşın"
            },
            "gjuha-arabe": {
                title: "Arapça",
                description:
                    "Arapça okuma, yazma ve anlama kursu. Ayrıntılar, kursun yeniden başlama tarihi belli olduğunda duyurulacaktır.",
                level: "Yeniden başlatılması planlanıyor",
                format: "Çevrimiçi",
                badge: "",
                summary: "",
                cta: "Daha fazla bilgi için bize ulaşın"
            }
        }
    },

    courseForm: {
        name: "Ad soyad",
        phone: "Telefon numarası",
        email: "E-posta adresi",
        course: "İlgilendiğiniz kurs",
        message: "Mesaj",
        optional: "(isteğe bağlı)",
        messagePlaceholder: "Sorularınızı veya isteklerinizi yazın.",
        notice: "Bu formu doldurmak, kursa kesin kayıt anlamına gelmez.",
        submit: "Talebi gönder",
        submitting: "Gönderiliyor…",
        successTitle: "Talebiniz gönderildi",
        successText:
            "İlginiz için teşekkür ederiz. Seçtiğiniz kurs için yeni bir grup açıldığında sizinle iletişime geçeceğiz.",
        again: "Yeni bir talep gönder",
        errors: {
            name: "Lütfen adınızı yazın.",
            phone: "Lütfen geçerli bir telefon numarası yazın.",
            email: "Lütfen geçerli bir e-posta adresi yazın.",
            course: "Lütfen bir kurs seçin.",
            generic: "Talebiniz gönderilemedi. Lütfen tekrar deneyin."
        }
    },

    contact: {
        seoTitle: "İletişim",
        seoDescription:
            "Kitap siparişi, Kur’an ve dil kurslarına kayıt veya iş birliği için Germa Enstitüsü’ne yazın. En kısa sürede yanıt veriyoruz.",
        title: "Bize ulaşın",
        description:
            "Kitap siparişi, kurs kaydı, iş birliği ya da çalışmalarımızla ilgili sorularınız için bize yazın.",
        crumb: "İletişim",
        howTitle: "Bize nasıl ulaşabilirsiniz?",
        howText: "Bize e-posta ile ya da form aracılığıyla yazabilirsiniz.",
        email: "E-posta",
        response: "Yanıt süresi",
        responseValue: "3 gün içinde",
        follow: "Bizi sosyal medyada takip edin"
    },

    contactForm: {
        name: "Ad soyad",
        namePlaceholder: "Adınız ve soyadınız",
        email: "E-posta adresi",
        emailPlaceholder: "siz@ornek.com",
        subject: "Konu",
        optional: "(isteğe bağlı)",
        subjectPlaceholder: "Ne hakkında yazıyorsunuz?",
        message: "Mesaj",
        messagePlaceholder: "Mesajınızı buraya yazın.",
        submit: "Mesajı gönder",
        submitting: "Gönderiliyor…",
        successTitle: "Teşekkür ederiz!",
        successText: "Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.",
        again: "Yeni bir mesaj gönder",
        errors: {
            name: "Lütfen adınızı yazın.",
            email: "Lütfen geçerli bir e-posta adresi yazın.",
            message: "Lütfen biraz daha uzun bir mesaj yazın.",
            generic: "Mesajınız gönderilemedi. Lütfen tekrar deneyin."
        }
    },

    about: {
        seoTitle: "Hakkımızda",
        seoDescription:
            "Germa Enstitüsü, Jusuf Kastrati tarafından kurulan; yayıncılık, çeviri, Kur’an ve dil kursları alanında çalışan bir kültür ve eğitim kurumudur.",
        title: "Germa Enstitüsü",
        description: "Kitaplar ve eğitim yoluyla ilmin ve eğitimin hizmetinde.",
        crumb: "Hakkımızda",
        missionTitle: "Misyonumuz",
        mission: [
            "Germa Enstitüsü; yayıncılık, çeviri ve eğitim alanlarında faaliyet gösteren bir kültür ve eğitim kurumudur. Dinî, dil ve eğitim alanlarında eserler yayımlıyor, Kur’an okuma ve dil kursları düzenliyor, video dersler ve ders materyalleri hazırlıyoruz.",
            "Yayınlarımızda içeriğin doğruluğuna, çevirinin ve dil redaksiyonunun kalitesine özen gösteriyoruz. Kurslarımızda ise anlatımı, öğrencilerin seviyesine ve ihtiyaçlarına göre uygulamalı alıştırmalarla birleştiriyoruz."
        ],
        valuesTitle: "Çalışma ilkelerimiz",
        values: [
            {
                title: "Doğruluk",
                text: "Güvenilir kaynaklara dayanıyor, içerikleri yayımlamadan önce dinî ve dilsel doğruluk açısından titizlikle gözden geçiriyoruz."
            },
            {
                title: "Açıklık",
                text: "Akıcı bir dil ve anlaşılır açıklamalar kullanıyor, ön bilgi gerektiren kavram ve konuları açıklıyoruz."
            },
            {
                title: "Öğrenciye özen",
                text: "Dersleri öğrencilerin yaşına ve bilgi düzeyine göre uyarlıyor, sorularına alan açıyor ve adım adım ilerlemelerine yardımcı oluyoruz."
            },
            {
                title: "Sorumluluk",
                text: "Görüş ve önerileri memnuniyetle karşılıyor, yayınlarımızda ve materyallerimizde fark edilen hataları düzeltiyoruz."
            }
        ],
        leadership: "Yönetim",
        founderShort: "Kurucu ve müdür",
        portraitAlt: "{name} portresi",
        directorRole: "Germa Enstitüsü’nün kurucusu ve müdürü",
        directorBio: [
            "Germa Enstitüsü, kurucusu ve müdürü Jusuf Kastrati tarafından yönetilmektedir. Riyad’daki İmam Muhammed bin Suud İslam Üniversitesi Şeriat Fakültesi’nde İslam hukuku ve usulü alanında lisans eğitimini tamamladı. Aynı üniversitede İslam Kültürü alanında yüksek lisans yaptı; hâlen Tunus’taki Zeytûne Üniversitesi’nde İslam Medeniyeti alanında doktora eğitimine devam etmektedir.",
            "İslami eserlerin çevirisi ve öğretmenlik alanında uzun yıllara dayanan bir tecrübeye sahiptir. Dinî kitaplar çevirmiş; Arnavutça ve Almanca anlatımla Kur’an okuma ve Arapça kursları vermiştir. Çalışmalarının özel bir bölümünü gençlerin din eğitimine ayırmıştır."
        ]
    },

    kurani: {
        seoTitle: "Kur’an-ı Kerim ve Arnavutça meâli",
        seoDescription:
            "Kur’an-ı Kerim’in Arapça metnini, Jusuf Kastrati’nin Arnavutça meâliyle birlikte Kurani.info’da ücretsiz okuyun.",
        title: "Kur’an-ı Kerim",
        subtitle: "Meâlinin Arnavutçaya çevirisi",
        description:
            "Kur’an-ı Kerim’i, Jusuf H. Kastrati’nin Arnavutça meâliyle birlikte okuyun. Meâl, Kurani.info’da ücretsiz olarak erişime açıktır.",
        crumb: "Kur’an",
        readOn: "Kurani.info’da okuyun",
        logoAlt: "Kurani.info platformunun logosu",
        aboutTitle: "Meâl hakkında",
        about: [
            "Bu meâl, ayetlerin anlamlarını Arnavut okura doğru biçimde ve açık, akıcı bir Arnavutçayla aktarmak amacıyla hazırlanmıştır. Çalışma güvenilir tefsirlere dayanmakta olup pek çok dinî ve dilsel incelemeden geçmiştir.",
            "Her çeviri, ayetlerin anlamlarını aktarmaya yönelik insani bir çabadır ve aslın dilsel ve anlamsal zenginliğini tam olarak yansıtamaz. Bu nedenle meâl, Kur’an’ı anlamaya yardımcı bir araçtır; Kur’an ise Allah’ın Arapça olarak indirdiği Kitap’ın kendisidir."
        ],
        featuresTitle: "Meâlin özellikleri",
        features: [
            {
                title: "Doğruluk ve sadakat",
                text: "Güvenilir tefsirlere dayanarak ayetlerin anlamlarını aktarmada titizlik."
            },
            {
                title: "Açık ve akıcı Arnavutça",
                text: "Kur’an üslubunun özelliklerini, dilin imkânları ölçüsünde korumaya çalışan açık ve akıcı bir Arnavutça."
            },
            {
                title: "Üslup ve terminoloji birliği",
                text: "Terimlerin tutarlı kullanımı ve Arnavutçada yerleşmiş İslami terimlerin korunması."
            },
            {
                title: "Kısa dipnotlar",
                text: "Ek açıklama gereken yerlerde okurun ayetleri anlamasına yardımcı olan notlar."
            },
            {
                title: "Dinî ve dilsel inceleme",
                text: "Anlamların ve Arnavutça ifadenin doğruluğu için ilgili alanların uzmanlarınca tekrarlanan incelemeler."
            },
            {
                title: "Ücretsiz erişim",
                text: "Meâl internette ücretsiz okunabilir. Elektronik sürüm, yeni düzeltme ve iyileştirmelerle güncellenmesine imkân verir."
            }
        ],
        translatorBadge: "Mütercim",
        translatorRole: "İslam Medeniyeti alanında doktora öğrencisi",
        translatorText:
            "Kur’an-ı Kerim meâlinin Arnavutçaya çevirisi, uzun yıllara yayılan bir araştırma, çeviri ve redaksiyon çalışmasının ürünüdür.",
        teamTitle: "Redaksiyon ve inceleme ekibi",
        roles: {
            religious: "Dinî redaksiyon",
            consulting: "Dinî danışmanlık",
            language: "Dil redaksiyonu"
        },
        noteTitle: "Not",
        note: "Bu meâl, redaksiyon ve ilmî incelemenin son aşamalarındadır. Kur’an-ı Kerim’in anlamlarının mümkün olduğunca doğru aktarılmasına katkı sağlayacak her türlü görüş ve öneriyi memnuniyetle karşılıyoruz.",
        writeUs: "Bize yazın",
        ctaTitle: "Meâli okuyun",
        ctaText: "Arapça metni, Arnavutça meâli ve açıklayıcı dipnotları Kurani.info’da bulabilirsiniz.",
        ctaButton: "Kurani.info’yu açın"
    },

    search: {
        open: "Ara",
        title: "Portalda ara",
        placeholder: "Kitap, sesli kitap, video ders, kurs arayın…",
        close: "Aramayı kapat",
        hint: "Aramak için en az iki harf yazın.",
        empty: "“{query}” için sonuç bulunamadı.",
        error: "Arama yapılamadı. Lütfen biraz sonra tekrar deneyin.",
        loading: "Aranıyor…",
        groups: {
            books: "Kitaplar",
            audiobooks: "Sesli kitaplar",
            videos: "Video dersler",
            courses: "Kurslar"
        }
    },

    offline: {
        title: "İnternet bağlantınız yok",
        text: "Bu sayfa henüz bu cihaza kaydedilmedi. İnternete yeniden bağlandığınızda tekrar deneyin. Bu arada daha önce açtığınız kitapları okuyabilirsiniz.",
        retry: "Tekrar dene",
        home: "Ana sayfa",
        savedTitle: "Çevrimdışı okumak için kaydedilen kitaplar",
        savedEmpty: "Henüz kaydedilmiş kitabınız yok. Sitenin okuyucusunda açtığınız her kitap bu cihaza otomatik olarak kaydedilir."
    },

    pwa: {
        install: "Uygulamayı yükle"
    },

    notFound: {
        title: "Sayfa bulunamadı",
        text: "Sayfa taşınmış ya da artık mevcut olmayabilir. İlim yolculuğunuza devam etmek için ana sayfaya dönün.",
        back: "Ana sayfaya dön"
    },

    serverError: {
        title: "Bir sorun oluştu",
        text: "Beklenmeyen bir hata oluştu. Lütfen biraz sonra tekrar deneyin.",
        back: "Ana sayfaya dön"
    }
}
